
// import "swiper/css";
import { Link } from "react-router-dom"

import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

const swiperOptions = {
	modules: [Autoplay, Pagination, Navigation],
	spaceBetween: 30,
	speed: 2000,
	loop: true,
	autoplay: {
		delay: 2000,
		disableOnInteraction: false,
	},
	pagination: {
		el: ".dot",
		clickable: true,
	},
	navigation: {
		nextEl: ".array-prev",
		prevEl: ".array-next",
	},
	breakpoints: {
		1399: {
			slidesPerView: 4,
		},
		1199: {
			slidesPerView: 3,
		},
		991: {
			slidesPerView: 2,
		},
		767: {
			slidesPerView: 2,
		},
		575: {
			slidesPerView: 1,
		},
		0: {
			slidesPerView: 1,
		},
	},
}

export default function Service1() {
	return (
		<>
			<section
				className="service-section fix section-padding bg-cover"
				style={{ backgroundImage: 'url("assets/img/service/service-bg.jpg")' }}
			>
				<div className="container">
					<div className="section-title text-center">
						<h6 className="wow fadeInUp">
							<i className="fa-regular fa-arrow-left-long" />
							What We Offer
							<i className="fa-regular fa-arrow-right-long" />
						</h6>
						<h2 className="wow fadeInUp text-white" data-wow-delay=".2s">
						Engineered WPC Doors & <br/> Frames for Every Space
						</h2>
					</div>
					<div className="array-button">
						<button className="array-prev h1p">
							<i className="fa-regular fa-arrow-left-long" />
						</button>
						<button className="array-next h1n">
							<i className="fa-regular fa-arrow-right-long" />
						</button>
					</div>
				</div>
				<div className="container-fluid">
					<div className="swiper service-slider">
						<Swiper {...swiperOptions} className="swiper-wrapper">
							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										<img src="assets/img/icon/Icon_1.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
									</div>
									<div className="service-content">
										<h2 className="number">01</h2>
										<h3>
											<Link to="/service-details">Termite & Pest Proof</Link>
										</h3>
										<p>
											Built to resist damage from insects, unlike traditional wooden doors.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>
							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										<img src="assets/img/icon/Icon_2.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
										{/* <div className="icon">
											<i className="fa-regular fa-truck-front" />
										</div> */}
									</div>
									<div className="service-content">
										<h2 className="number">02</h2>
										<h3>
											<Link to="/service-details">100% Waterproof</Link>
										</h3>
										<p>
											No warping or swelling – perfect for kitchens, bathrooms, and balconies.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>
							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										<img src="assets/img/icon/Icon_3.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
										{/* <div className="icon">
											<i className="fas fa-pallet" />
										</div> */}
									</div>
									<div className="service-content">
										<h2 className="number">03</h2>
										<h3>
											<Link to="/service-details">Fire Retardant</Link>
										</h3>
										<p>
											Enhanced fire safety for residential and commercial applications.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>
							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										<img src="assets/img/icon/Icon_4.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
										{/* <div className="icon">
											<i className="fas fa-shipping-fast" />
										</div> */}
									</div>
									<div className="service-content" style={{ height: '400px' }}>
										<h2 className="number">04</h2>
										<h3>
											<Link to="/service-details">Chemical Resistant</Link>
										</h3>
										<p>
											Suitable for use in hospitals, labs, and industrial spaces.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
										<img src="assets/img/icon/Icon_5.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
									</div>
									<div className="service-content">
										<h2 className="number">05</h2>
										<h3>
											<Link to="/service-details">Eco-Friendly</Link>
										</h3>
										<p>
											Made from recycled material. A sustainable choice for green projects.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
										<img src="assets/img/icon/Icon_6.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
									</div>
									<div className="service-content">
										<h2 className="number">06</h2>
										<h3>
											<Link to="/service-details">Matt & Glossy Finishes</Link>
										</h3>
										<p>
											Choose between smooth glossy or elegant matte textures.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
										<img src="assets/img/icon/Icon_7.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
									</div>
									<div className="service-content">
										<h2 className="number">07</h2>
										<h3>
											<Link to="/service-details">Lightweight, Yet Strong</Link>
										</h3>
										<p>
											Easy to handle and install without compromising on strength.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
										<img src="assets/img/icon/Icon_8.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
									</div>
									<div className="service-content">
										<h2 className="number">08</h2>
										<h3>
											<Link to="/service-details">Custom Sizes Available</Link>
										</h3>
										<p>
											Get frames and doors tailored for your unique project.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
										<img src="assets/img/icon/Icon_9.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
									</div>
									<div className="service-content">
										<h2 className="number">09</h2>
										<h3>
											<Link to="/service-details">Indoor & Outdoor Use</Link>
										</h3>
										<p>
											Designed to perform in different interior zones.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>

							<SwiperSlide className="swiper-slide">
								<div className="service-box-items" style={{ height: '400px' }}>
									<div className="service-thumb">
										<img src="assets/img/icon/Icon_10.png" alt="img" style={{ height: '150px', objectFit: 'contain' }} />
										{/* <div className="icon">
											<i className="fa-regular fa-truck-fast" />
										</div> */}
									</div>
									<div className="service-content">
										<h2 className="number">10</h2>
										<h3>
											<Link to="/service-details">Lead-Free</Link>
										</h3>
										<p>
										Lead-free manufacturing ensures safer doors for all environments.
										</p>
										{/* <Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link> */}
									</div>
								</div>
							</SwiperSlide>
							{/* <SwiperSlide className="swiper-slide">
								<div className="service-box-items">
									<div className="service-thumb">
										<img src="assets/img/service/02.jpg" alt="img" />
										<div className="icon">
											<i className="fa-regular fa-truck-front" />
										</div>
									</div>
									<div className="service-content">
										<h2 className="number">02</h2>
										<h3>
											<Link to="/service-details">Airplane Fright</Link>
										</h3>
										<p>
											Consectetur Phasellus a odio vel sapien pharetra placerat.
										</p>
										<Link to="/service-details" className="link-btn">
											Explore More <i className="fa-solid fa-arrow-right" />
										</Link>
									</div>
								</div>
							</SwiperSlide> */}
						</Swiper>
					</div>
				</div>
			</section>
		</>
	)
}
